import React from 'react'

const Skeleton = () => {
	return (
		<div className='bg-neutral-200 rounded-md w-full p-5 '></div>
	)
}

export default Skeleton